/* eslint-disable import/no-anonymous-default-export */
import { Tabs } from "./../../../components/ui/ot"
import AutoReplyMain from "../../../components/auto_reply/views/AutoReplyMain"
import NoReplyMain from "../../../components/no_reply/views/NoReplyMain"
import { useState } from "react"
import AuroReplySettingForm from "../../../components/auto_reply/views/AuroReplySettingForm"
import Can from './../../../components/can/views/Can'
import TemplateType from "./../../../components/template/views/TemplateType";
import { Row, Col } from './../../../components/ui/ot'

export default () => {
    const [activeKey, setActiveKey] = useState('ChatbotMessage')
    return (<>
        {/* <Main_header
            show_import='none'
            display_type
            function_title='機器人自動回覆訊息'
            function_description='透過關鍵字讓機器人進行自動回覆'
        /> */}
        <Tabs
            items={[
                {
                    key: 'ChatbotMessage',
                    tab: '自動回覆訊息'
                },
                {
                    key: 'Can',
                    tab: '訊息樣板'
                },
                {
                    key: 'TemplateType',
                    tab: '訊息樣板分類'
                },
                ...(false ? [{
                    key: 'ChatbotSetting',
                    tab: '聊天回覆方式'
                }] : []),
                {
                    key: 'ChatbotNoReply',
                    tab: '無法回覆訊息'
                },
            ]}
            activeKey={activeKey}
            onChange={setActiveKey}
        />
        {activeKey === "Can" && (<>
            <Row>
                <Col span={24}>
                    <Can />
                </Col>
            </Row>
        </>)}
        {activeKey === "TemplateType" && (<>
            <Row>
                <Col span={24}>
                    <TemplateType />
                </Col>
            </Row>
        </>)}
        {activeKey === "ChatbotMessage" && (<>
            <AutoReplyMain />
        </>)}
        {false && activeKey === "ChatbotSetting" && (<>
            <AuroReplySettingForm />
        </>)}
        {activeKey === "ChatbotNoReply" && (<>
            <NoReplyMain
                setActiveKey={setActiveKey}
            />
        </>)}
    </>)
}